module.exports = __webpack_public_path__ + "img/mini-bodoir.08aec327.jpg";